import {
    IconBackArrowLeft,
    IconChatAsk,
    IconChevronRightSmall,
    IconClose,
    IconEmail,
    IconHintFilled,
} from '@holbonkit/icons'
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
    BottomSheet,
    BottomSheetBody,
    BottomSheetClose,
    BottomSheetContent,
    BottomSheetHeader,
    BottomSheetTitle,
    BottomSheetTrigger,
    Box,
    Text,
} from '@holbonkit/ui'

import styles from './address-bottom-sheet.module.scss'

export const AddressBottomSheet = () => {
    return (
        <BottomSheet>
            <BottomSheetTrigger>
                <button className={styles['address__button']} type='button'>
                    <IconHintFilled color='var(--extensions-text-and-icon-success)' size={20} />{' '}
                    Подробнее о налоговом резиденстве
                </button>
            </BottomSheetTrigger>
            <BottomSheetContent showCloseButton={false}>
                <BottomSheetHeader className={styles['bottom-sheet__header']}>
                    <BottomSheetTitle>Чем вам помочь?</BottomSheetTitle>
                    <Box className={styles['bottom-sheet__header-back']}>
                        <IconBackArrowLeft color='var(--text-and-icon-primary)' size={24} />
                    </Box>
                    <BottomSheetClose>
                        <Box className={styles['bottom-sheet__header-close']}>
                            <IconClose color='var(--text-and-icon-primary)' size={20} />
                        </Box>
                    </BottomSheetClose>
                </BottomSheetHeader>
                <BottomSheetBody>
                    <Text className={styles['accordion__title']} variant='body-m-16-bold'>
                        Вопросы
                    </Text>
                    <Accordion className={styles['accordion']}>
                        <AccordionItem className={styles['accordion__item']} value='item-1'>
                            <AccordionTrigger className={styles['accordion__trigger']}>
                                Что такое налоговое резидентство
                            </AccordionTrigger>
                            <AccordionContent className={styles['accordion__content']}>
                                Это статус, который зависит от времени вашего пребывания в стране, а
                                не от гражданства. Если вы находитесь в России более 183 дней в
                                течение года, вы становитесь налоговым резидентом.
                            </AccordionContent>
                        </AccordionItem>
                    </Accordion>
                    <Text className={styles['accordion__title']} variant='body-m-16-bold'>
                        Остались вопросы?
                    </Text>
                    <button
                        className={styles['bottom-sheet__button']}
                        type='button'
                        onClick={() => (globalThis.location.href = 'drivee://open/driver/support')}
                    >
                        <Box className={styles['bottom-sheet__button-content']}>
                            <IconChatAsk color='var(--text-and-icon-primary)' />
                            <Text variant='body-m-16-medium'>
                                Написать в чат Службы
                                <br />
                                поддержки
                            </Text>
                        </Box>
                        <IconChevronRightSmall color='var(--text-and-icon-secondary)' />
                    </button>
                    <button
                        className={styles['bottom-sheet__button']}
                        type='button'
                        onClick={() => (globalThis.location.href = 'mailto:support@drivee.com')}
                    >
                        <Box className={styles['bottom-sheet__button-content']}>
                            <IconEmail color='var(--text-and-icon-primary)' />
                            <Text variant='body-m-16-medium'>
                                Написать на почту
                                <br />
                                <Text
                                    as='span'
                                    className={styles['bottom-sheet__button-content--subtext']}
                                    variant='body-s-14-medium'
                                >
                                    support@drivee.com
                                </Text>
                            </Text>
                        </Box>
                        <IconChevronRightSmall color='var(--text-and-icon-secondary)' />
                    </button>
                </BottomSheetBody>
            </BottomSheetContent>
        </BottomSheet>
    )
}
